import { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from '../../dashboard';
var AdminRefundComponent = /** @class */ (function () {
    function AdminRefundComponent(dashboardService, router) {
        this.dashboardService = dashboardService;
        this.router = router;
        this.subscriptions = [];
        this.search = {};
        this.users = [];
        this.msgTitle = "";
        this.msgContent = "";
        this.popUp = false;
    }
    AdminRefundComponent.prototype.ngOnInit = function () {
    };
    AdminRefundComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    AdminRefundComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    AdminRefundComponent.prototype.refundSearch = function () {
        var _this = this;
        var s1 = this.dashboardService.refundSearch(this.search).subscribe(function (res) {
            _this.users = res.courses;
            console.log('users');
            console.log(_this.users);
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s1);
    };
    AdminRefundComponent.prototype.refundClick = function (courseId, attendeeId) {
        var _this = this;
        var s2 = this.dashboardService.refundInit(courseId, attendeeId).subscribe(function (res) {
            _this.users = [];
            _this.msgTitle = "Success";
            _this.msgContent = "Refund is in progress!!";
            _this.popUp = true;
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s2);
    };
    return AdminRefundComponent;
}());
export { AdminRefundComponent };
//# sourceMappingURL=adminRefund.component.js.map